import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function ExportBadge() {
  const { user } = useAuth();  // ← přímo z AuthContextu
  const [diffDays, setDiffDays] = useState(null);
  const [neverUploaded, setNeverUploaded] = useState(false);

  useEffect(() => {
    if (!user?.pharmacyCode) return;

    const firma = user.firma || "LEMON";

    (async () => {
      try {
        const res = await fetch(`/api/upload/${firma}/${user.pharmacyCode}/meta`);
        if (!res.ok) return;

        const data = await res.json();

        if (!data?.lastBatch) {
          setNeverUploaded(true);
          return;
        }

        const last = new Date(data.lastBatch);
        const days = Math.floor((Date.now() - last) / (1000 * 60 * 60 * 24));

        if (days > 7) setDiffDays(days);
      } catch (err) {
        console.error("ExportBadge error:", err);
      }
    })();
  }, [user]);

  if (neverUploaded) {
    return (
      <span className="ml-2 text-rose-600 font-bold text-lg leading-none">
        ❗
      </span>
    );
  }

  if (diffDays !== null) {
    return (
      <span className="relative flex items-center gap-1">
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-rose-600"></span>
        </span>
        <span className="text-xs font-bold text-rose-600">+{diffDays}</span>
      </span>
    );
  }

  return null;
}
